import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import InfoHeader from "./InfoHeader";
import SplitPanel from "../../../Helpers/SplitPanel";
import InfoPanel from "../../../Helpers/InfoPanel";
import { prettyDates, capitalize } from "../../../../actions/utils";
import { Button } from "@material-ui/core";
import { setProfilePic } from "../../../../actions/userActions";
import { connect } from "react-redux";
import { bucketUrl } from '../../../../actions/utils'

const empty = "-";
class TenantInformation extends Component {

    static propTypes = {
        title: PropTypes.node
    }

    constructor(props) {
        super(props);
        this.compared = this.compared.bind(this);
    }

    compared(key, title, value) {
        if (!this.props.compare) {
            return [title, value];
        }
        const match = key === null ? null : (this.props.compare || {})[key];
        return [
            (<div>
                <span className={match !== false ? match !== null ? "Information-match-positive" : "Information-match-unresolved" : "Information-match-negative"}>
                    <div className="Information-match" />
                </span>
                <span>
                    {title}
                </span>
            </div>),
            (value === empty ? empty : <div className="Information-value">{value}</div>)
        ];
    }

    translateProfile(profile, preferred, isUser) {

        const translateArray = (array) => {
            if (!array)
                return empty;
            let matches;
            if (Array.isArray(array)) {
                matches = array;
            }
            else if (typeof array === "string") {
                if (array === "{}")
                    return empty;
                const arrayRegex = /"[^"]+"/g;
                const captures = array.match(arrayRegex);
                if (!captures)
                    matches = [array];
                else
                    matches = captures.map(m => m.substring(1, m.length - 1));
            }
            let result = "";
            for (let i = 0; i < matches.length; i++) {
                result = `${result}${result ? ", " : ""}${capitalize(matches[i])}`;
            }
            return result;
        }

        const translateOccupation = (occupation) => {
            if (!occupation)
                return empty;
            let result = "";
            if (occupation.work)
                result = `${result}${result ? ", " : ""}Working`;
            if (occupation.student)
                result = `${result}${result ? ", " : ""}Student`;
            return result || empty;
        }

        const translateOperatingMargin = (operatingMargin) => {
            if (Array.isArray(operatingMargin)) {
                if (operatingMargin.length === 0)
                    return empty;
                let result = "";
                for (let i = 0; i < operatingMargin.length; i++) {
                    result = `${result}${result ? ", " : ""}${translateOperatingMargin(operatingMargin[i])}`;
                }
                return result;
            }
            else {
                switch (operatingMargin) {
                    case "negative": return "Negative";
                    case "postitive": return "1-10000 $";
                    case "higher": return "10000+ $";
                    default: return empty;
                }
            }
        }

        const translateIndustries = (industries) => {
            if (!industries || !Array.isArray(industries))
                return empty;
            let result = "";
            for (let i = 0; i < industries.length; i++) {
                switch (industries[i]) {
                    case "mn": result = `${result}${result ? ", " : ""}Manufacturing`; break;
                    case "fi": result = `${result}${result ? ", " : ""}Financial services`; break;
                    case "tr": result = `${result}${result ? ", " : ""}Transportation`; break;
                    case "ed": result = `${result}${result ? ", " : ""}Education`; break;
                    case "ti": result = `${result}${result ? ", " : ""}Tiertiary industry`; break;
                    case "hc": result = `${result}${result ? ", " : ""}Health care`; break;
                    case "ht": result = `${result}${result ? ", " : ""}Hospitality`; break;
                    case "mi": result = `${result}${result ? ", " : ""}Media industry`; break;
                    case "ot": result = `${result}${result ? ", " : ""}Other`; break;
                    default: result = `${result}${result ? ", " : ""}${empty}`;
                }
            }
            return result;
        }

        const result = [];
        if (isUser) result.push(["Email:", profile.email || empty]);

        if (profile.privateTenant) {
            const person = profile.privateTenant;
            if (!preferred) {
                result.push([
                    "Full name:",
                    `${person.firstName || ""} ${person.lastName || ""}`,
                ]);
                result.push(["Phone number:", person.phoneNumber]);
                result.push([
                    "Current address:",
                    person.currentAddress || empty,
                ]);
            }
        }

        if (profile.organizationTenant) {
            const org = profile.organizationTenant;
            if (!preferred) {
                result.push(["Company:", org.name]);
                result.push(["Business ID:", org.businessId]);
                result.push(["Current address:", org.currentAddress]);
                result.push(["Phone number:", org.phoneNumber]);
                result.push([
                    "Contact full name:",
                    `${org.contactFirstName || ""} ${org.contactLastName ||
                    ""}`,
                ]);
                result.push(["Contact phone number:", org.contactPhoneNumber]);
                result.push(["Contact email:", org.contactEmail]);
                result.push(["Contact address:", org.contactAddress]);
                result.push(["Billing address:", org.billingAddress]);
                result.push(["Online invoice:", org.onlineInvoice]);
                result.push(["Employee count:", org.employeeCount]);
                result.push(["Turnover:", org.turnover]);
                result.push(this.compared("industries", "Industry:", translateIndustries(org.industry)));
            }
        }

        // if (preferred) {
        //     return result.filter(r => r[1] !== empty);
        // }

        // if ( !preferred )
        //     result.push( [ "Full name:", `${profile.firstName || ""} ${profile.lastName || ""}` ] );
        // if ( isUser )
        //     result.push( [ "Email:", profile.email || empty ] );
        // if ( !preferred )
        //     result.push( [ "Phone number:", profile.phoneNumber ] );



        result.push(this.compared("creditRating", "Credit rating:", translateArray(profile.creditRating)));


        {/*
            if ( !preferred )
            result.push( [ "Birthday:", profile.birthday ? prettyDates.year( profile.birthday ) : empty ] );

        if ( !preferred )
            result.push( [ "Current address:", profile.currentAddress || empty ] );
        result.push( this.compared( "occupation", "Occupation:", translateOccupation( profile.occupation ) ) );
        if ( profile.occupation ) {
            if ( profile.occupation.work )
                result.push( [ "Work details:", profile.occupation.workDetails || empty ] );
            if ( profile.occupation.student )
                result.push( [ "Student details:", profile.occupation.studentDetails || empty ] );
        }
         */}
        result.push(this.compared("operatingMargin", "Operating margin:", translateOperatingMargin(profile.operatingMargin)));
        // result.push( this.compared( "employee", "No. of employee:", ( profile.employee !== undefined && profile.employee !== null ) ? ( profile.employee >= 6 ? "6+" : profile.employee ) : empty ) );



        // if ( !preferred )
        //     result.push( this.compared( "yourCompanyName", "Your Company name:", profile.yourCompanyName || empty ) );

        // if ( preferred ) {
        //     return result.filter( r => r[1] !== empty );
        // }

        return result;
    }

    render() {
        const { title, profile, isUser, preferred, dispatch } = this.props;
        const prettyProfile = this.translateProfile(profile, preferred, isUser);

        const profilePicUploadButton = (
            <Fragment>
                <input
                    onChange={(e) => {
                        e.preventDefault();
                        const file = e.target.files[0];
                        dispatch(setProfilePic(file))
                    }}
                    accept="image/png"
                    id="profilepic-upload-button"
                    type="file"
                    hidden
                />
                <label htmlFor="profilepic-upload-button">
                    <Button
                        variant="outlined"
                        component="span"
                        color="primary"
                    // size="large"
                    >
                        Upload
                    </Button>
                </label>
            </Fragment>
        );

        return (
            <div className="Information-section">
                <InfoHeader>
                    {title || ""}
                </InfoHeader>
                {preferred &&
                    <SplitPanel
                        left={
                            <InfoPanel
                                rows={prettyProfile.slice(0, Math.floor(prettyProfile.length / 2))}
                            />
                        }
                        right={
                            <InfoPanel
                                rows={prettyProfile.slice(Math.floor(prettyProfile.length / 2), prettyProfile.length)}
                            />
                        }
                    />
                }
                {!preferred &&
                    <SplitPanel
                        left={
                            <InfoPanel
                                rows={prettyProfile}
                            />
                        }
                        right={
                            <div>
                                Short description:
                                <br />
                                <br />
                                {profile.description || "No description"}
                                <br />
                                <br />
                                <br />
                                <br />
                                Profile picture:
                                <br />
                                <br />

                                {this.props.profile.file ? <img style={{ maxHeight: 250, padding: 10 }} src={`${bucketUrl}/${this.props.profile.file.key}`} alt='profile' /> : <p>No image yet</p>}
                                {isUser && profilePicUploadButton}
                            </div>
                        }
                    />
                }
            </div>
        );
    }

}

export default connect(
    state => {
        return {

        }
    },
    dispatch => {
        return {
            dispatch: dispatch
        }
    }
)(TenantInformation)